/* eslint-disable max-len */
import React from 'react';

export const ReplyIcon = props => (
  <svg {...props} width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M6.91421 9.00008L9.20711 11.293L7.79289 12.7072L3.79289 8.70718C3.40237 8.31666 3.40237 7.68349 3.79289 7.29297L7.79289 3.29297L9.20711 4.70718L6.91421 7.00008H14.5C16.1569 7.00008 17.5 8.34322 17.5 10.0001V16.0001H15.5V10.0001C15.5 9.44779 15.0523 9.00008 14.5 9.00008H6.91421Z" fill="#212121" />
  </svg>
);

